import styled from "styled-components";

export const StyledCustomerReviewBlock = styled.div`
  border: 1px solid #f0f0f0;
  background-color: #fafafa;
  padding: 1.6rem;
  border-radius: 8px;
`;

export const StyledCustomerReviewBlockStarsAndDateWrapper = styled.div`
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
`;
export const StyledCustomerReviewBlockStarsAndDate = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.6rem;
`;
